// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T910","colBig":"styles_colBig__3KrGv","colSmall":"styles_colSmall__1zGi0"};